<template>
  <div>
    <vxe-grid
      ref="xTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :tree-config="{ children: 'childs' }"
      :data="tableData"
      :columns="tableColumns"
      size="small"
      border
      resizable
      :edit-config="{ trigger: 'click', mode: 'row' }"
      show-footer
      :footer-method="footerMethod"
      @zoom="zoom"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame">
            <span style="font-size: 14px; color: #606266">{{
              $l('table_label_quarterly_budget') || '季度预算'
            }}</span>
            <el-divider direction="vertical"></el-divider>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              v-if="allow('A')"
              v-show="reportBudgetCode != ''"
              :disabled="disabled"
              @click="addQuarter()"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div v-if="!disabled" v-show="row.reportBudgetCustomerCode">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-edit tool-btn" @click="editQuarter(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
    <EditFormDialog
      ref="editForm"
      v-if="editFormDialogParams.visible"
      :visible.sync="editFormDialogParams.visible"
      :disabled="editFormDialogParams.disabled"
      :budgetType="editFormDialogParams.budgetType"
      :reportBudgetCode="reportBudgetCode"
      :quarterData="editFormDialogParams.quarterData"
      :title="editFormDialogParams.title"
      :quarterVisible="editFormDialogParams.quarterVisible"
      @reload="reload"
    />
  </div>
</template>
<script>
import EditFormDialog from '../edit-form/index.vue'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import Math from '@/libs/util.math.js'
import { format } from '@/libs/util.number.js'

export default {
  components: { EditFormDialog },
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    reportBudgetCode: {
      type: String,
      default: '',
    },
  },
  computed: {
    footerData() {
      if (!this.tableData) return 0
      var estimatedQty = 0
      var subBudget = 0
      var budgetQ1 = 0
      var budgetQ2 = 0
      var budgetQ3 = 0
      var budgetQ4 = 0

      this.tableData.forEach(
        (i) => (
          (estimatedQty = this.add(estimatedQty, i.estimatedQty)),
          (subBudget = this.add(subBudget, i.subBudget)),
          (budgetQ1 = this.add(budgetQ1, i.budgetQ1)),
          (budgetQ2 = this.add(budgetQ2, i.budgetQ2)),
          (budgetQ3 = this.add(budgetQ3, i.budgetQ3)),
          (budgetQ4 = this.add(budgetQ4, i.budgetQ4))
        )
      )
      return [
        [
          '',
          this.$l('INDEX.total') || '合计',
          format(estimatedQty),
          format(subBudget),
          format(budgetQ1),
          format(budgetQ2),
          format(budgetQ3),
          format(budgetQ4),
        ],
      ]
    },
    tableRef() {
      return this.$refs.table
    },
    tableColumns() {
      return [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          width: 130,
          fixed: 'right',
          slots: {
            default: 'opt',
          },
          visible: !this.disabled && !this.isMax,
        },
        {
          title: this.$l('table_label_cust_name') || '客户名称',
          headerAlign: 'center',
          align: 'left',
          minWidth: '250',
          field: 'custName',
          showOverflow: true,
          treeNode: true,
        },
        {
          title: this.$l('table_label_estimated_quantity') || '预计数量',
          headerAlign: 'center',
          align: 'center',
          minWidth: '100',
          field: 'estimatedQtyText',
          showOverflow: true,
        },
        {
          title: this.$l('table_label_subBudget') || '预算小计',
          headerAlign: 'center',
          align: 'center',
          minWidth: '100',
          field: 'subBudget',
          showOverflow: true,
          formatter: ({ row }) => {
            const { subBudget: value } = row
            return format(value)
          },
        },
        {
          title: this.$l('table_label_first_quarter_budget') || '一季度预算',
          headerAlign: 'center',
          align: 'center',
          minWidth: '100',
          field: 'budgetQ1Text',
          showOverflow: true,
        },
        {
          title: this.$l('table_label_second_quarter_budget') || '二季度预算',
          headerAlign: 'center',
          align: 'center',
          minWidth: '100',
          field: 'budgetQ2Text',
          showOverflow: true,
        },
        {
          title: this.$l('table_label_third_quarter_budget') || '三季度预算',
          headerAlign: 'center',
          align: 'center',
          minWidth: '100',
          field: 'budgetQ3Text',
          showOverflow: true,
        },
        {
          title: this.$l('table_label_fourth_quarter_budget') || '四季度预算',
          headerAlign: 'center',
          align: 'center',
          minWidth: '100',
          field: 'budgetQ4Text',
          showOverflow: true,
        },
      ]
    }
  },
  data() {
    return {
      addVisible: false,
      isMax: false,
      budgetType: 'Q',
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
      },
      type: 'checkbox',
      editFormDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        budgetType: '',
        quarterData: {},
      },
    }
  },
  methods: {
     getHeight() {
      this.tableHeight = window.innerHeight - 50  - 225
      if(this.tableHeight < 306) {
        this.tableHeight = 306
      }
    },
    footerMethod() {
      // 返回一个二维数组的表尾合计
      return this.footerData
    },
    reload() {
      this.$emit('reload')
    },
    openEditFormDialog({ type, params = {} }) {
      const types = {
        add: this.$l('INDEX.product_dialog_btn_add') || '添加',
        edit: this.$l('INDEX.btn_modify') || '修改',
        detail: this.$l('INDEX.btn_tips_view') || '查看',
      }
      if (!params.uuid) {
        params.uuid = this.getUUID()
      }
      this.editFormDialogParams = {
        visible: true,
        title: types[type],
        quarterData: params,
        quarterVisible: this.budgetType === 'Q',
        disabled: type === 'detail',
      }
    },
    openChooseSample() {
      this.addVisible = true
    },
    zoom({ type }) {
      this.isMax = type == 'max'
    },

    delRow(row) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.loadingOpen()
          this.$api
            .orderBudgetCustomerQuarterDelApi({
              reportBudgetCustomerCode: row.reportBudgetCustomerCode,
              reportBudgetCode: this.reportBudgetCode,
            })
            .then((res) => {
              const { status } = res || {}
              if (status !== 200) {
                this.$message.error(
                  this.$l('INDEX.tips_delete_no') || '删除失败！'
                )
                return
              }
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
                type: 'success',
              })
              this.$emit('reload')
              this.loadingClose()
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    //保存时需要
    getGoodsData() {
      return this.tableData
    },
    addData(res) {
      if (!res) return
      const newArr = res.custCode + res.masterCategoryCode
      for (let index = 0; index < this.tableData.length; index++) {
        if (
          newArr ===
            this.tableData[index].custCode +
              this.tableData[index].masterCategoryCode &&
          res.uuid != this.tableData[index].uuid
        ) {
          this.$message.warning(
            this.$l('from_label_the_same_customer_cannot_be_duplicate') ||
              '一个预算单中，相同客户与产品类别不能重复!'
          )
          return
        }
        if (res.uuid === this.tableData[index].uuid) {
          this.$set(this.tableData, index, res)
          this.updateTotBudget()
          this.$refs.editForm.close()

          return
        }
      }
      this.tableData.push(res)
      this.$refs.editForm.close()
      this.updateTotBudget()
    },
    updateTotBudget() {
      var totBudget = 0
      this.tableData.forEach((i) => {
        totBudget = this.add(totBudget, i.subBudget)
      })
      this.$emit('updateTotBudget', totBudget)
    },
    addQuarter() {
      if (!this.budgetType) {
        this.$message.warning(
          this.$l('from_label_ps_budget_method') || '请选择预算方式'
        )
        return
      }
      this.openEditFormDialog({
        type: 'add',
        params: { budgetMonthList: [] },
      })
    },
    editQuarter(row) {
      if (!this.budgetType) {
        this.$message.warning(
          this.$l('from_label_ps_budget_method') || '请选择预算方式'
        )
        return
      }
      this.openEditFormDialog({
        type: 'edit',
        params: row,
      })
    },
    /* eslint-disable */
    updateBudgetType(val) {
      // this.budgetType = val ? val : ''
    },

    getUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },
    add(x, y) {
      x = x || 0
      y = y || 0
      return Math.number(Math.add(Math.bignumber(x), Math.bignumber(y)))
    },
  },
}
</script>
